import { getEditorOperateState } from '../states/editor-operate-state';
import { ICursorTipArgs } from '../type';

/** 光标提示 */
export class CursorTip {
    constructor(private readonly identity: string) {}

    /** 光标提示信息 */
    private data: ICursorTipArgs | null = null;

    /** 设置光标提示语 */
    set(args: ICursorTipArgs) {
        this.data = args;
        getEditorOperateState(this.identity).setCursorTipVer();
    }

    /** 清空光标提示语 */
    clear() {
        this.data = null;
        getEditorOperateState(this.identity).setCursorTipVer(0);
    }

    /** 获取光标提示信息 */
    getInfo() {
        return this.data;
    }
}
